import React from 'react';
import PropTypes from 'prop-types';

import CtaButton from 'components/essentials/Cta/CtaButton';
import ProtectionPlans from 'components/consumer/ProtectionPlans';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import StandardModal from 'components/consumer/StandardModal';
import MobileOnly from '../MobileOnly';

const ProtectionPlanModal = ({
  buttonRef,
  cartItemId,
  close = () => null,
  eligiblePlans,
  forPage = 'cart',
  isOpen = false,
  onSelect = null,
  selectedPlan,
}) => {
  const closeAndFocusOnButton = e => {
    close(e);
    buttonRef?.current?.focus();
  };

  return (
    <StandardModal
      isOpen={isOpen}
      onClose={closeAndFocusOnButton}
      showOkButtonOnMobile={false}
      size="md"
      titleAlignment="center"
    >
      <div className="w-full relative font-normal text-gray">
        <MobileOnly>
          <div className="max-[1023px]:hidden lg:hidden absolute top-2.5 right-4">
            <CtaButton
              styling="link"
              color="white"
              noLinkPadding
              onClick={close}
              hasArrow={false}
            >
              No, thanks
            </CtaButton>
          </div>
        </MobileOnly>

        <div className="text-left text-white pt-0 px-0 pb-4 max-w-[80%] md:text-center md:max-w-full">
          <div className="text-2xl font-bold max-[1023px]:mx-0 max-[1023px]:-mt-2 max-[1023px]:mb-2">
            5-Year Protection Plans
          </div>
          <div className="text-base text-white md:text-sm md:text-white">
            When an accident happens, know your investment is protected.
          </div>
        </div>

        <ProtectionPlans
          cartItemId={cartItemId}
          eligiblePlans={eligiblePlans}
          forPage={forPage}
          onAdd={close}
          onRemove={close}
          onSelect={onSelect}
          selectedPlan={selectedPlan}
          showImages
        />

        <div className="mt-4">
          <div className="text-xs pt-4 px-0 text-center text-brand-lighter [&_svg]:top-1 [&_svg]:relative [&_svg]:ml-4 [&_a:visited]:visited:underline [&_a:visited]:visited:text-white">
            <span>
              In partnership with ServeCo. See the{' '}
              <a
                className="underline text-[inherit]"
                href="/furniture-protection-plan/"
                target="_blank"
              >
                full terms here.
              </a>
            </span>
          </div>
        </div>
      </div>
    </StandardModal>
  );
};

ProtectionPlanModal.propTypes = {
  buttonRef: PropTypes.object,
  cartItemId: PropTypes.string,
  close: PropTypes.func,
  eligiblePlans: PropTypes.array,
  forPage: PropTypes.oneOf([
    'cart',
    'checkout',
    'PDP',
    'UserDashboardPP',
    'UserDashboardOrdersPage',
  ]),
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  selectedPlan: PropTypes.object,
};

export default withBrowserOnly(ProtectionPlanModal);
